import React, { useState, FC, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Slider from 'react-slick';

import chevronRightBlack from '../../../images/common/chevron-right-black.svg';
import chevronRightBlue from '../../../images/common/chevron-right-blue.svg';
import {
  MainStyled,
  TextColumn,
  PreTitle,
  Title,
  Subtitle,
  ButtonContainer,
  NextCaseBtn,
  ImageColumn,
  CardsContainer,
  Card,
  SliderContainer,
  PaginationPill,
} from './style';

interface Props {
  currentCase: string | undefined;
  nextCase: string | undefined;
  mainTitle: string;
  subTitle: string;
  hero: string;
  icon: string;
  card1: string;
  card2: string;
  card3: string;
}

const Main: FC<Props> = (props) => {
  const { t } = useTranslation();
  let nextUrl = `/solutions/usecase/${props.nextCase}`;

  const [activeSlide, setActiveSlide] = useState(1);
  let settings = {
    dots: false,
    arrows: true,
    infinite: false,
    autoplay: false,
    speed: 500,
    slidesToShow: 1.2,
    slidesToScroll: 1,
    beforeChange: (current: number, next: number) => {
      if (next > 1) {
        setActiveSlide(next + 1.2);
      } else {
        setActiveSlide(next + 1);
      }
    },
  };
  const slider = useRef<any>();
  useEffect(() => {
    slider.current.slickGoTo(0);
  }, [nextUrl]);

  return (
    <MainStyled>
      <div className="container">
        <TextColumn className="animate__animated animate__fadeIn">
          <div className="top">
            <PreTitle
              dangerouslySetInnerHTML={{
                __html: t('UseCaseMainPreTitle'),
              }}
            />
            <img src={props.icon} alt="icon" />
            <Link to={nextUrl}>
              <NextCaseBtn>
                {t('UseCaseMainNextUseCaseMobile')}
                <img src={chevronRightBlack} alt="arrow icon" />
                <img src={chevronRightBlue} alt="arrow icon" />
              </NextCaseBtn>
            </Link>
          </div>
          <Title
            dangerouslySetInnerHTML={{ __html: props.mainTitle }}
            case={props.currentCase}
          />
          <Subtitle dangerouslySetInnerHTML={{ __html: props.subTitle }} />
          <ButtonContainer>
            <Link to={nextUrl}>
              <NextCaseBtn>
                {t('UseCaseMainNextUseCase')}
                <img src={chevronRightBlack} alt="arrow icon" />
                <img src={chevronRightBlue} alt="arrow icon" />
              </NextCaseBtn>
            </Link>
          </ButtonContainer>
        </TextColumn>
        <ImageColumn className="animate__animated animate__fadeIn">
          <img src={props.hero} alt="background" />
          <CardsContainer>
            <Card dangerouslySetInnerHTML={{ __html: props.card1 }} />
            <Card dangerouslySetInnerHTML={{ __html: props.card2 }} />
            <Card dangerouslySetInnerHTML={{ __html: props.card3 }} />
          </CardsContainer>
        </ImageColumn>
      </div>
      <SliderContainer>
        <Slider {...settings} ref={slider}>
          <Card dangerouslySetInnerHTML={{ __html: props.card1 }} />
          <Card dangerouslySetInnerHTML={{ __html: props.card2 }} />
          <Card dangerouslySetInnerHTML={{ __html: props.card3 }} />
        </Slider>
        <PaginationPill>{activeSlide}/3</PaginationPill>
      </SliderContainer>
    </MainStyled>
  );
};

export default Main;
